module.exports = __webpack_public_path__ + "static/media/hamburger_cream.d7ad65c9.svg";